import React from "react";
import Blok from "../../../interfaces/Storyblok/Blok.interface";
import DynamicComponent from "../../utils/DynamicComponent/DynamicComponent.component";

interface ColumnedHubspotFormProps extends Blok {
  section_title_block: Blok[];
  hubspot_form_block: Blok[];
}

const ColumnedHubspotForm: React.FC<ColumnedHubspotFormProps> = ({ section_title_block, hubspot_form_block }) => {
  return (
    <div>
      {/* Mobile: section title renders full-width above the form so the wave SVG isn't clipped */}
      <div className="md:hidden">
        {section_title_block?.map(blok => (
          <DynamicComponent blok={blok} key={blok._uid} />
        ))}
      </div>

      <div className="max-w-[1280px] mx-auto grid md:grid-cols-2">
        {/* Desktop: section title sits in the left column */}
        <div className="hidden md:block">
          {section_title_block?.map(blok => (
            <DynamicComponent blok={blok} key={blok._uid} />
          ))}
        </div>

        <div>
          {hubspot_form_block?.map(blok => (
            <DynamicComponent blok={blok} key={blok._uid} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ColumnedHubspotForm;
